export default {"src":"/_next/static/media/hamburger.b2c08eea.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};